/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from "react";
import "./admin.css";
import menuIcon from "../../../assets/imgs/navbar/menu-open.svg";
import menuIconClicked from "../../../assets/imgs/navbar/menu-closed.svg";
import perfilIcon from "../../../assets/imgs/dashboard-admin/logo-horus.png";
import conexiones_i from "../../../assets/imgs/navbar/conexiones.svg";
import camara_i from "../../../assets/imgs/navbar/icon.svg";
import gestion_i from "../../../assets/imgs/navbar/gestion.svg";
import { AiFillCaretDown } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Tooltip } from 'react-tooltip';
import {
  FaUserCheck,
  FaUserShield,
  FaSignOutAlt,
  FaFileInvoiceDollar,
  FaCreditCard,
  FaDolly,
  FaAddressCard,
  FaWarehouse,
  FaFileInvoice,
  FaPager,
  FaAlignCenter,
  FaListOl,
  FaSearch,
  FaThList,
  FaExclamationTriangle,
  FaCubes,
} from "react-icons/fa";
import { MdAssignment } from "react-icons/md";
import { LiaPalletSolid } from "react-icons/lia";
import { GrCatalog } from "react-icons/gr";
import { GiCooler } from "react-icons/gi";
import { FaListUl, FaClipboardList } from "react-icons/fa6";
import { RiMailSendLine } from "react-icons/ri";
import { BsFileEarmarkTextFill } from "react-icons/bs";
import { PiAirplaneTilt } from "react-icons/pi";
import { TfiFiles } from "react-icons/tfi";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { HiInboxArrowDown } from "react-icons/hi2";
import { BiDollar } from "react-icons/bi";
import { BsWindowDash } from "react-icons/bs";
import { PiNotepad } from "react-icons/pi";
import { GrClipboard } from "react-icons/gr";
import { FaRegCheckSquare } from "react-icons/fa";
import { FaPlaneArrival } from "react-icons/fa";
import { FaPlaneDeparture } from "react-icons/fa";
import { PiCirclesThreeLight } from "react-icons/pi";
import { FaTimes } from "react-icons/fa";
import { FaBars } from "react-icons/fa";

import ReactTimeAgo from "react-time-ago";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/es"; // Agrega los locales que necesites, por ejemplo, 'es' para español

//login
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import Swal from "sweetalert2";
import UserNotFound from "../components/user-not-found/user-not-found";
import Loading from "../components/loading/loading";
import SessionExpired from "../../../components/session-expired/session-expired";

import MainBanner from "../../../components/dashboard/main-banner/main-banner";
import { Collapse } from "react-collapse";

//Vistas
import Bienvenido from "./bienvenido/bienvenido";
import Usuarios from "./usuarios/usuarios";
import Permisos from "./permisos/permisos";
import Tarimas from "./tarimas/tarimas";
import RemitentesConsignatarios from "./remitentes-consignatarios/remitentes-consignatarios";
import LiftTrucks from "./lift-trucks/lift-trucks";
import CoolerUsers from "./cooler_users/cooler_users";
import Warehouses from "./iwarehouses/iwarehouses";
import PaymentConditions from "./payment-conditions/payment-conditions";
import PaymentTypes from "./payment-types/payment-types";
import Agents from "./agents/agents";
import Institutions from "./institutions/institutions";
import ClientsExpo from "./clients-expo/clients_expo";
import Irregularity from "./irregularity_types/irregularity_types";
import CFDITypes from "./cfdi-types/cfdi-types";
import Clients from "./clients/clients";
import Users from "./users/users";
import PasswordExp from "./password-exp/passwordExp";
import PerfilesUsuario from "./users_profile/users_profile";

import Capture from "./export/capture/capture";
import Assignment from "./export/assignment/assignment";
import Exp_Irregularities_sat from "./export/irregularities_sat/irregularities_sat";
import UPD from "./export/upd-m-h/upd";
import { useNavigate } from "react-router-dom";
import Entries from "./export/entries/entries";
import Billing from "./export/billing/billing";
import Auditor from "./export/auditor/auditor";
import Acas from "./export/acas/acas-main";
import Acceptance from "./export/acceptance/acceptance";
import Departures from "./export/departures/departures";
import Withdrawals from "./export/withdrawals/withdrawals";
import Lags from "./export/lags/lags";
import Incidents from "./incidents/incidents";
import Milestones from "./milestones/milestones";
import AddExtras from "./add-extras/add-extras";
import KardexTransits from "./kardex-transits/kardex-transits";
import CheckInFlights from "./checkIn-flights/checkin-flights";

import KardexExpo from "./others/kardex_expo/kardex_expo";
import Quoter from "./others/quoter/quoter";
import Exceptions from "./others/exceptions/exceptions";
import BatchBilling from "./others/batch_billing/batch_billing";
import BatchCancellation from "./others/batch_cancellation/batch_cancellation";
import TradingRules from "./others/trading-rules/trading-rules";
import ULDS from "./ulds/ulds";
import ReportTransit from "./repor_transit/report_transit";

import MenuImportacion from "./menu_redisenio/importacion"
import MenuConexiones from "./menu_redisenio/conexiones"
import MenuCamaraFria from "./menu_redisenio/camara"
import MenuExportacion from "./menu_redisenio/exportacion"
import MenuGestion from "./menu_redisenio/gestion"
import ExternalDesWarehouses from "./external_des_warehouses/external_des_warehouses";
import ValeCooler from "./cooler/vale-cooler/valeCooler";

import DashboardCooler from "./cooler/dashboard-cooler/dashboard-cooler";

function Admin() {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [imgUser, setImgUser] = useState(perfilIcon);
  const [selectedComponent, setSelectedComponent] = useState("");
  const [isCatalogOpen, setIsCatalogOpen] = useState(false);
  const [click, setClick] = useState(false);
  const [isCheckboxCollapseOpen1, setIsCheckboxCollapseOpen1] = useState(false);
  const [isCheckboxCollapseOpen2, setIsCheckboxCollapseOpen2] = useState(false);
  const [isCheckboxCollapseOpen3, setIsCheckboxCollapseOpen3] = useState(false);
  const [activePath, setActivePath] = useState("");
  
  const [permissions, setPermissions] = useState([]);

  const navigate = useNavigate();
  const [activeIcon, setActiveIcon] = useState(null);
  const [showMainSections, setShowMainSections] = useState(false);

  const handleIconClick = () => {
    setShowMainSections(!showMainSections);
  };

  useEffect(() => {
    const handlePopState = (event) => {
      const shouldLeave = window.confirm(
        "¿Estás seguro de que quieres salir de esta página?"
      );
      if (shouldLeave) {
        navigate("/dashboard/admin", { replace: true });
      } else {
        // Evita la navegación hacia atrás
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Agrega una entrada extra al historial para poder interceptar la navegación hacia atrás
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    // También podrías prevenir el cierre de pestaña o recarga
    window.onbeforeunload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Esto hace que el navegador muestre la advertencia
    };

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.onbeforeunload = null;
    };
  }, [navigate]);

  // useEffect(() => {
  //   const emailRegularExpression =
  //     /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;

  //   const loginWithRetries = async (data, retries = 5) => {
  //     for (let attempt = 1; attempt <= retries; attempt++) {
  //       try {
  //         const response = await axios.post(
  //           `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/login`,
  //           data
  //         );

  //         if (response.data.code === 1) {
  //           Swal.fire({
  //             title: "Usuario logeado exitosamente",
  //             icon: "success",
  //           });

  //           const data = {
  //             id: response.data.user.id,
  //             first_name: response.data.user.first_name,
  //             last_name: response.data.user.last_name,
  //             email: response.data.user.email,
  //             role_id: response.data.user.role_id,
  //           };

  //           localStorage.setItem("user", JSON.stringify(data));
  //           sessionStorage.setItem("token", response.data.user.token);
  //           sessionStorage.setItem(
  //             "tokenExpire",
  //             response.data.user.tokenExpiration
  //           );
  //           localStorage.setItem("username", user.nickname);
  //           localStorage.setItem("photo", user.picture);

  //           // const permissions = await axios.get(
  //           //   `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${response.data.user.id}`,
  //           //   {
  //           //     headers: {
  //           //       Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //           //     },
  //           //   }
  //           // );

  //           // localStorage.setItem(
  //           //   "permissions",
  //           //   JSON.stringify(permissions.data.data)
  //           // );
  //           // setPermissions(permissions.data.data);

  //           // Si la respuesta es exitosa, salir del bucle y marcar como datos obtenidos.
  //           setHasFetchedData(true);
  //           break;
  //         }
  //       } catch (error) {
  //         console.error("error: ", error);
  //         // Mostrar alerta solo en el último intento fallido.
  //         if (attempt === retries) {
  //           setShowAlert(true);
  //           setHasFetchedData(true); // Marcar como datos obtenidos en el último intento fallido.
  //         }
  //       }
  //     }
  //   };

  //   if (isAuthenticated && !hasFetchedData) {
  //     const email = user.email.match(emailRegularExpression);
  //     setImgUser(perfilIcon);

  //     const data = { email: email[0], key: process.env.REACT_APP_KEY };

  //     loginWithRetries(data);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuthenticated, hasFetchedData]);

  const logoutAdmin = () => {
    localStorage.clear();
    sessionStorage.clear();
    logout({ logoutParams: { returnTo: process.env.REACT_APP_LOGOUT_URL } });
  };

  const onChange1 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen1(checked),
    [setIsCheckboxCollapseOpen1]
  );

  const onChange2 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen2(checked),
    [setIsCheckboxCollapseOpen2]
  );

  const onChange3 = useCallback(
    ({ target: { checked } }) => setIsCheckboxCollapseOpen3(checked),
    [setIsCheckboxCollapseOpen3]
  );

  const sectionNames = {
    Usuarios: "Usuarios",
    Permisos: "Permisos",
    Tarimas: "Tarimas",
    CoolerUsers: "Usuarios Cooler",
    ExternalDesWarehouses: "Almacenes externos destino",
    Agents: "Agentes",
    PerfilesUsuario: "Perfil de Usuarios",
    RemitentesConsignatarios: "Remitentes/Consignatarios",
    AddRemitentesConsignatarios: "Agregar Remitente y consignatario",
    LiftTrucks: "Montacarguistas",
    PaymentConditions: "Condiciones de pago",
    PaymentTypes: "Tipos de pago",
    Irregularity: "Irregularidades",
    CFDITypes: "Tipos de CFDI",
    "Opción 1": "Opción 1",
    "Opción 2": "Opción 2",
    Institutions: "Instituciones",
    Clients: "Clientes",
    ClientsExpo: "Clientes Expo",
    Users: "Usuarios",
    PasswordExp: "Exp. Contraseñas",
    Incidents: "Incidencias",
    Capture: "Captura",
    Assignment: "Asignación",
    Exp_Irregularities_sat: "Irregularidades SAT Expo",
    UPD: "UPD",
    Entries: "Entradas",
    Billing: "Facturación",
    Auditor: "Auditor",
    ACAS: "ACAS",
    Acceptance: "Aceptación",
    Departures: "Salidas",
    Withdrawals: "Desistimientos",
    Lags: "Rezagos",
    KardexExpo: "Kárdex Exportación",
    Quoter: "Cotizador",
    Exceptions: "Excepciones",
    BatchBilling: "Batch de facturas no timbradas",
    BatchCancellation:
      "Batch de facturas canceladas en espera de UUID referenciado",
    TradingRules: "Reglas Comerciales",
    Milestones: "Milestones",
    AddExtras: "Altas Tránsitos",
    KardexTransits: "Kárdex Tránsitos",
    CheckInFlights: "Check In",
    Report_transit: "Tránsitos",
    ULDS: "ULD's",
    ValeCooler: "Cooler",
    DashboardCooler: "Dashboard Cooler"
  };

  const getSectionIcon = (section) => {
    switch (section) {
      case "Usuarios":
        return <FaUserCheck className="fs-5 align-self-center" />;

      case "Permisos":
        return <FaUserShield className="fs-5 align-self-center" />;

      case "Tarimas":
        return <LiaPalletSolid className="fs-5 align-self-center" />;

      case "RemitentesConsignatarios":
        return <RiMailSendLine className="fs-5 align-self-center" />;

      case "LiftTrucks":
        return <FaDolly className="fs-5 align-self-center" />;

      case "CoolerUsers":
        return <GiCooler className="fs-5 align-self-center" />;

      case "ExternalDesWarehouses":
        return <FaWarehouse className="fs-5 align-self-center" />;

      case "PaymentConditions":
        return <FaFileInvoiceDollar className="fs-5 align-self-center" />;

      case "PaymentTypes":
        return <FaCreditCard className="fs-5 align-self-center" />;

      case "Agents":
        return <FaListUl className="fs-5 align-self-center" />;

      case "PerfilesUsuario":
        return <FaListUl className="fs-5 align-self-center" />;

      case "Institutions":
        return <FaListUl className="fs-5 align-self-center" />;

      case "Irregularity":
        return <FaListUl className="fs-5 align-self-center" />;

      case "Clients":
        return <FaAddressCard className="fs-5 align-self-center" />;

      case "CFDITypes":
        return <FaFileInvoice className="fs-5 align-self-center" />;

      case "Users":
        return <FaFileInvoice className="fs-5 align-self-center" />;
      case "Opción 1":
      case "Opción 2":
        return <GrCatalog className="fs-5 align-self-center" />;

      case "ClientsExpo":
        return <FaAddressCard className="fs-5 align-self-center" />;

      case "PasswordExp":
        return <FaPager className="fs-5 align-self-center" />;

      case "Incidents":
        return <FaPager className="fs-5 align-self-center" />;

      case "Capture":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "Assignment":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "Exp_Irregularities_sat":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "UPD":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "Entries":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "Billing":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "Auditor":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "ACAS":
        return <FaClipboardList className="fs-5 align-self-center" />;

      case "Acceptance":
        return <HiInboxArrowDown className="fs-5 align-self-center" />;

      case "Departures":
        return <FaClipboardList className="fs-5 align-self-center" />;

      case "Withdrawals":
        return <FaClipboardList className="fs-5 align-self-center" />;

      case "Lags":
        return <FaClipboardList className="fs-5 align-self-center" />;

      case "KardexExpo":
        return <FaAlignCenter className="fs-5 align-self-center" />;

      case "Quoter":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "Exceptions":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "TradingRules":
        return <BsFileEarmarkTextFill className="fs-5 align-self-center" />;

      case "BatchBilling":
        return <FaSearch className="fs-5 align-self-center" />;

      case "BatchCancellation":
        return <FaSearch className="fs-5 align-self-center" />;

      case "Milestones":
        return <FaListUl className="fs-5 align-self-center" />;

      case "AddExtras":
        return <FaListUl className="fs-5 align-self-center" />;

      case "KardexTransits":
        return <FaListUl className="fs-5 align-self-center" />;

      case "CheckInFlights":
        return <FaRegCheckSquare className="fs-5 align-self-center" />;

      case "ULDS":
        return <FaListUl className="fs-5 align-self-center" />;

      case "Cooler":
        return <FaListUl className="fs-5 align-self-center" />;

      default:
        return null;
    }
  };

  const handleMenuClick = (componentName) => {
    setSelectedComponent(componentName);
    closeMobileMenu();
  };

  const handleMenuClick1 = (componentName) => {
    setSelectedComponent(componentName);
    closeMobileMenu();
  };

  const handleMenuClick2 = (componentName) => {
    setSelectedComponent(componentName);
    closeMobileMenu();
  };

  const closeMobileMenu = () => setClick(false);
  const handleClick = () => setClick(!click);

  const toggleCatalogDropdown = () => {
    setIsCatalogOpen(!isCatalogOpen);
  };

  // if (!isAuthenticated && !isLoading)
  //   return (
  //     <>
  //       <SessionExpired />
  //     </>
  //   );

  const RenderPathSegments = ({ pathString }) => {
      if (!pathString) {
          return null;
      }

      // 1. Reemplazamos guiones bajos por espacios para mejor lectura
      const normalizedPath = pathString.replace(/_/g, ' ');

      // 2. Dividimos la cadena por el separador de ruta ('/')
      const segments = normalizedPath.split('/');

      return (
          <div className="path-segment-container d-flex align-items-center">
              {segments.map((segment, index) => {
                  const isLast = index === segments.length - 1;
                  
                  // Procesamiento y Capitalización de la palabra para visualización
                  const displaySegment = segment.split(' ')
                      .map(word => {
                          if (['de', 'la', 'el', 'y', 'a'].includes(word.toLowerCase())) {
                              return word.toLowerCase();
                          }
                          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                      })
                      .join(' ');

                  return (
                      // Usamos React.Fragment para agrupar el segmento y el separador sin añadir un <div> extra
                      <React.Fragment key={index}>
                          {/* El segmento de la ruta, con clase 'last' si es el final */}
                          <span className={isLast ? "path-last-segment" : "path-segment-item"}>
                              {displaySegment}
                          </span>
                          
                          {/* El separador (barra diagonal) */}
                          {!isLast && <span className="path-separator mx-1">/</span>}
                      </React.Fragment>
                  );
              })}
          </div>
      );
  };

  const normalizePathForDisplay = (pathString) => {
      if (!pathString) return '';

      // Convertimos la ruta a un formato legible (reemplazando '_')
      let cleanedPath = pathString.replace(/_/g, ' ');

      // Dividimos por el separador de ruta ('/') para procesar cada segmento
      return cleanedPath.split('/')
          .map(segment => {
              // Dividimos el segmento en palabras, las capitalizamos y las unimos
              return segment.split(' ')
                  .map(word => {
                      // Mantenemos artículos/conjunciones comunes en minúscula
                      if (['de', 'la', 'el', 'y', 'a'].includes(word.toLowerCase())) {
                          return word.toLowerCase();
                      }
                      // Capitaliza la primera letra de la palabra
                      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                  })
                  .join(' '); // Unimos las palabras del segmento con espacios
          })
          .join(' / '); // Unimos los segmentos con el separador visual ' / '
  };

  const handleComponentChange = (componentName, newActivePath) => {
      setSelectedComponent(componentName);      
      const cleanedPathForDisplay = normalizePathForDisplay(newActivePath);
      setActivePath(cleanedPathForDisplay);
      // Aquí podrías agregar lógica de historial o logs si es necesario
      console.log("Admin.js: Componente seleccionado:", componentName);
  };

  //if (isLoading || !hasFetchedData) return <Loading />;
  const TOOLTIP_ID = "importacion-tip"; 
  return (
    <div className="container-fluid p-0 m-0">
      {/*{!showAlert ? (*/}
        <>
          <MainBanner />

          <div className="welcome-bar">
            <p>
              {!activeIcon
                ? `¡Bienvenido a Horus, ${localStorage.getItem("username")}!`
                : activeIcon === "importacion"
                ? "Importación"
                : activeIcon === "exportacion"
                ? "Exportación"
                : activeIcon === "gestion_de_almacen"
                ? "Gestión de Almacén"
                : activeIcon === "conexiones"
                ? "Conexiones"
                : activeIcon === "camara_fria"
                ? "Cámara Fría"
                : "Otros"}
            </p>
          </div>

          <div className="d-flex">
            <div className="admin-menu">
              <div className="menu-icon-open-close" onClick={handleClick}>
                {click ? <FaTimes size={28} /> : <FaBars size={28} />}
                {/* <img
                  src={click ? menuIconClicked : menuIcon}
                  alt={click ? "Closed Menu" : "Open Menu"}
                /> */}
              </div>

              <div className={click ? "menu-admin active" : "menu-admin"}>
                <div className="d-flex flex-column">
                  <div className=" d-flex justify-content-center">
                    <img className="admin-profile-img" src={imgUser} alt="" />
                  </div>
                  <div className=" d-flex justify-content-center">
                   <p><font size="1" className="text-white">V. 1.0</font></p>
                  </div>
                </div>

                <div className="d-flex">
                  <div className="d-flex align-items-center mx-1">
                    <div
                      className={`icon-circle d-flex align-items-center justify-content-center mb-1 ${
                        activeIcon === "importacion" ? "active" : ""
                      }`}
                      onClick={() =>
                        setActiveIcon(
                          activeIcon === "importacion" ? null : "importacion"
                        )
                      }
                      data-tooltip-id={TOOLTIP_ID}
                      data-tooltip-content="Importación"
                      data-tooltip-place="Top"
                    >
                      <FaPlaneArrival className="fs-5 text-white" />
                    </div>
                    <Tooltip id={TOOLTIP_ID} 
                    className="dark-tooltip"/>
                  </div>
                  <div className="d-flex align-items-center mx-1">
                    <div
                      className={`icon-circle d-flex align-items-center justify-content-center mb-1 ${
                        activeIcon === "conexiones" ? "active" : ""
                      }`}
                      onClick={() =>
                        setActiveIcon(
                          setActiveIcon === "conexiones" ? null : "conexiones"
                        )
                      }
                      data-tooltip-id={TOOLTIP_ID}
                      data-tooltip-content="Conexiones"
                      data-tooltip-place="Top"
                    >
                     <img src={conexiones_i} alt="" />
                    </div>
                    <Tooltip id={TOOLTIP_ID} 
                    className="dark-tooltip"/>
                  </div>

                  <div className="d-flex align-items-center mx-1">
                    <div
                      className={`icon-circle d-flex align-items-center justify-content-center mb-1 ${
                        activeIcon === "camara_fria" ? "active" : ""
                      }`}
                      onClick={() =>
                        setActiveIcon(
                          setActiveIcon === "camara_fria" ? null : "camara_fria"
                        )
                      }
                      data-tooltip-id={TOOLTIP_ID}
                      data-tooltip-content="Cámara Fría"
                      data-tooltip-place="Top"
                      
                    >
                      <img src={camara_i} alt="" />
                    </div>
                    <Tooltip id={TOOLTIP_ID} 
                    className="dark-tooltip"/>
                  </div>

                  <div className="d-flex align-items-center mx-1">
                    <div
                      className={`icon-circle d-flex align-items-center justify-content-center mb-1 ${
                        activeIcon === "exportacion" ? "active" : ""
                      }`}
                      onClick={() =>
                        setActiveIcon(
                          setActiveIcon === "exportacion" ? null : "exportacion"
                        )
                      }
                      data-tooltip-id={TOOLTIP_ID}
                      data-tooltip-content="Exportación"
                      data-tooltip-place="Top"
                    >
                      <FaPlaneDeparture className="fs-5 text-white " />
                    </div>
                    <Tooltip id={TOOLTIP_ID} 
                    className="dark-tooltip"/>
                  </div>

                  <div className="d-flex align-items-center mx-1">
                    <div
                      className={`icon-circle d-flex align-items-center justify-content-center mb-1 ${
                        activeIcon === "gestion_de_almacen" ? "active" : ""
                      }`}
                      onClick={() =>
                        setActiveIcon(
                          setActiveIcon === "gestion_de_almacen" ? null : "gestion_de_almacen"
                        )
                      }
                      data-tooltip-id={TOOLTIP_ID}
                      data-tooltip-content="Gestión de Almacén"
                      data-tooltip-place="Top"
                    >
                      <img src={gestion_i} alt="" />
                    </div>
                    <Tooltip id={TOOLTIP_ID} 
                    className="dark-tooltip"/>
                  </div>

                 
                </div>

                <div className="sidebar-scroll">
                  {activeIcon === "importacion" && (
                    <MenuImportacion onComponentChange={handleComponentChange} />
                  )}

                  {activeIcon === "exportacion" && (
                    <MenuExportacion onComponentChange={handleComponentChange} />
                  )}

                  {activeIcon === "conexiones" && (
                    <MenuConexiones onComponentChange={handleComponentChange} />
                  )}

                  {activeIcon === "gestion_de_almacen" && (
                    <MenuGestion onComponentChange={handleComponentChange} />
                  )}

                  {activeIcon === "camara_fria" && (
                    <MenuCamaraFria onComponentChange={handleComponentChange} />
                  )}

                </div>

                <div className="logout-container">
                  <button className="button-logout">
                    <div
                      className="text-menu-item-logout text-center w-100"
                      onClick={logoutAdmin}
                    >
                      <FaSignOutAlt className="fs-5" />
                      <p className="ps-2 m-0"><b>Cerrar sesión</b></p>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="main-content flex-grow-1">
                {selectedComponent === "" ? (
                  <div className="menu-item-content"></div>
                ) : (
                  <div className="menu-item-content-vistas">
                    <div className="row mb-3">
                      {activeIcon && selectedComponent && (
                        <div className="breadcrumb-bar px-3 py-2">
                          <small>
                             <RenderPathSegments pathString={activePath} />
                          </small>
                        </div>
                      )}
                    </div>
                    <div className="main-panel px-2 py-2">
                      <h4>{sectionNames[selectedComponent]}</h4>
                      <div className="main-panel-body">
                        {selectedComponent === "Usuarios" && <Usuarios />}
                        {selectedComponent === "Permisos" && <Permisos />}
                        {selectedComponent === "Tarimas" && <Tarimas />}
                        {selectedComponent === "RemitentesConsignatarios" && (
                          <RemitentesConsignatarios
                            handleMenuClick={handleMenuClick}
                          />
                        )}
                        {selectedComponent === "LiftTrucks" && <LiftTrucks />}
                        {selectedComponent === "CoolerUsers" && <CoolerUsers />}
                        {selectedComponent === "ExternalDesWarehouses" && <ExternalDesWarehouses />}
                        {selectedComponent === "PaymentConditions" && (
                          <PaymentConditions />
                        )}
                        {selectedComponent === "PaymentTypes" && (
                          <PaymentTypes />
                        )}
                        {selectedComponent === "Agents" && <Agents />}
                        {selectedComponent === "PerfilesUsuario" && (
                          <PerfilesUsuario />
                        )}
                        {selectedComponent === "Institutions" && (
                          <Institutions />
                        )}
                        {selectedComponent === "CFDITypes" && <CFDITypes />}
                        {selectedComponent === "Irregularity" && (
                          <Irregularity />
                        )}
                        {selectedComponent === "Clients" && <Clients />}
                        {selectedComponent === "ClientsExpo" && <ClientsExpo />}
                        {selectedComponent === "Users" && <Users />}
                        {selectedComponent === "PasswordExp" && <PasswordExp />}
                        {selectedComponent === "Incidents" && <Incidents />}

                        {selectedComponent === "Assignment" && <Assignment />}
                        {selectedComponent === "Capture" && <Capture />}
                        {selectedComponent === "UPD" && <UPD />}
                        {selectedComponent === "Entries" && <Entries />}
                        {selectedComponent === "Exp_Irregularities_sat" && (
                          <Exp_Irregularities_sat />
                        )}
                        {selectedComponent === "Billing" && <Billing />}
                        {selectedComponent === "Auditor" && <Auditor />}
                        {selectedComponent === "ACAS" && <Acas />}
                        {selectedComponent === "Acceptance" && <Acceptance />}
                        {selectedComponent === "Departures" && <Departures />}
                        {selectedComponent === "Withdrawals" && <Withdrawals />}
                        {selectedComponent === "Lags" && <Lags />}

                        {selectedComponent === "KardexExpo" && <KardexExpo />}
                        {selectedComponent === "Quoter" && <Quoter />}
                        {selectedComponent === "Exceptions" && <Exceptions />}
                        {selectedComponent === "BatchBilling" && (
                          <BatchBilling />
                        )}
                        {selectedComponent === "BatchCancellation" && (
                          <BatchCancellation />
                        )}
                        {selectedComponent === "TradingRules" && (
                          <TradingRules />
                        )}
                        {selectedComponent === "Milestones" && <Milestones />}
                        {selectedComponent === "AddExtras" && <AddExtras />}
                        {selectedComponent === "ULDS" && <ULDS />}
                        {selectedComponent === "KardexTransits" && (
                          <KardexTransits />
                        )}
                        {selectedComponent === "CheckInFlights" && (
                          <CheckInFlights />
                        )}
                        {selectedComponent === "Report_transit" && (
                          <ReportTransit />
                        )}
                        {selectedComponent === "Cooler" && <ValeCooler />}
                        {selectedComponent === "DashboardCooler" && (
                          <DashboardCooler />
                        )}
                        {selectedComponent === "" && <Bienvenido />}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
       {/*}) : (
         <UserNotFound />
       )}*/}
    </div>
  );
}

export default Admin;
